export const INCREMENT='INCREMENT';
export const SENDQ='SENDQ';